const OpcaoMostrarBotoes = [
  { label: 'Configuração', id: 1 },
  { label: 'Proposta', id: 2 },
  { label: 'Configuração e Proposta', id: 3 },
  { label: 'Não apresentar', id: 4 },
];

export default OpcaoMostrarBotoes;
